export const LOAD_POKEMONS = 'LOAD_POKEMONS'
export const LOAD_POKEMONS_SUCCESS = 'LOAD_POKEMONS_SUCCESS'
export const LOAD_POKEMONS_FAILED = 'LOAD_POKEMONS_FAILED'
export const LOAD_PAGINATED_DATA = 'LOAD_PAGINATED_DATA'
export const LOAD_PAGINATED_DATA_SUCCESS = 'LOAD_PAGINATED_DATA_SUCCESS'
export const LOAD_PAGINATED_DATA_FAILED = 'LOAD_PAGINATED_DATA_FAILED'
export const LOAD_POKEMON_DETAILS = 'LOAD_POKEMON_DETAILS'
export const LOAD_ALL_POKEMONS = 'LOAD_ALL_POKEMONS'
export const SEARCH_POKEMON_NAME = 'SEARCH_POKEMON_NAME'
export const SEARCH_POKEMON_TYPE = 'SEARCH_POKEMON_TYPE'
export const GET_SEVERAL_ABILITY = 'GET_SEVERAL_ABILITY'
export const GET_SEVERAL_TYPE = 'GET_SEVERAL_TYPE'
export const SET_ABILITY_SLUG = 'SET_ABILITY_SLUG'
export const SET_TYPE_SLUG = 'SET_TYPE_SLUG'
export const SET_SEARCHED_NAME_SLUG = 'SET_SEARCHED_NAME_SLUG'
export const IS_FILTER_SWICHED = 'IS_FILTER_SWICHED'
export const SET_POKEMONS_PROP = 'SET_POKEMONS_PROP'